
import { selectHeader, selectHeaderAppSettings } from '../../store/selectors'

export const selectSearchMode = (store) => selectHeader(store).searchMode
export const selectGlobalSearchBar = (store) => selectHeader(store).globalSearchBar
export const selectGlobalSearchBarAppSettings = (store) => selectHeaderAppSettings(store).GlobalSearchBar